import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Logs from './components/Logs';
import LeadLogs from './components/LeadLogs';
import AIKeys from './components/AIKeys';
import ActivityLog from './components/ActivityLog';
import { PaymentCheckout, PaymentResult } from './components/PaymentPages';

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

const PrivateRoute = ({ children }) => {
    const token = getCookie('token');
    return token ? children : <Navigate to="/" />;
};

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/logs"
                    element={
                        <PrivateRoute>
                            <Logs />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/lead-logs"
                    element={
                        <PrivateRoute>
                            <LeadLogs />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/ai-keys"
                    element={
                        <PrivateRoute>
                            <AIKeys />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/activity"
                    element={
                        <PrivateRoute>
                            <ActivityLog />
                        </PrivateRoute>
                    }
                />
                {/* Public payment pages – no auth required, customers access via emailed link */}
                <Route path="/payment/checkout" element={<PaymentCheckout />} />
                <Route path="/payment/result" element={<PaymentResult />} />
            </Routes>
        </Router>
    );
};

export default App;
